import { TEST_RESULTS } from '../globals';
const ONGOING_TESTS = new Map();
function cacheTestResult(tester, test) {
    const cachedTestResult = TEST_RESULTS.get(tester);
    if (cachedTestResult !== undefined) {
        return cachedTestResult;
    }
    const ongoingTest = ONGOING_TESTS.get(tester);
    if (ongoingTest !== undefined) {
        return ongoingTest;
    }
    const synchronousTestResult = test();
    if (synchronousTestResult instanceof Promise) {
        ONGOING_TESTS.set(tester, synchronousTestResult);
        return synchronousTestResult
            .then((finalTestResult) => {
            ONGOING_TESTS.delete(tester);
            TEST_RESULTS.set(tester, finalTestResult);
            return finalTestResult;
        });
    }
    TEST_RESULTS.set(tester, synchronousTestResult);
    return synchronousTestResult;
}
export { cacheTestResult };
//# sourceMappingURL=/build/es2018/helpers/cache-test-result.js.map